import { reactive } from 'vue'

const theme = reactive({
  agentLogo: '',
  devLogo: 'logo.png',
  apiUrl: 'https://api.metaluxe.com.au/',
  bunnyApiUrl: 'https://api.bunny.net/',

  videoLibraryId: '',
  streamCdnUrl: '',
  streamApiKey: '',

  storageApiPassword: '560a27ac-ec9e-49b9-a0e0f723f5d0-37d1-4b09',
  cdnUrl: 'https://rana-pwa.b-cdn.net',
  devFolder: '/rana1',

  CinematicsIcon: '/img/ui-theme/videos-icon.svg',
  rendersIcon: '/img/ui-theme/renders-icon.svg',
  rangeIcon: '/img/ui-theme/range-icon.svg',
  panoramasIcon: '/img/ui-theme/panoramas-icon.svg',
  '360-ToursIcon': '/img/ui-theme/panoramas-icon.svg',

  dashboardMp4: '/theme/dashboard/background-video.mp4',

  // top level menu
  assetsMenuOrder: ['renders', '360-tour'],

  orderAssetsMenu: ['3 Bed', 'Amenities', 'Exterior'],

  RanaAsset: {
    panoramas: [0],
    panoramasName: ['Rana'],
    panoramasUrl: [''],
    balconyViews: [0],
    balconyViewsName: ['Rana'],
    balconyViewsUrl: ['https://storage.net-fs.com/hosting/7566552/167/'],
    floorplans: [],
    floorplansName: [],
    floorplansUrl: [],
  },
  bedAsset: {
    balconyViews: [0],
    balconyViewsName: ['Rana'],
    balconyViewsUrl: [''],
  },
  aminitiesAsset: {
    balconyViews: [0],
    balconyViewsName: ['Ranaa'],
    balconyViewsUrl: [''],
  },
})

export default { theme }
